import React, { useState, useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "../../src/Css/CarouselNewsSection.css";
import Image1 from "../assets/homepage/2.jpg";
import Image2 from "../assets/homepage/3.jpg";
import Image3 from "../assets/homepage/4.jpg";
import Image4 from "../assets/homepage/5.jpg";
import Image5 from "../assets/homepage/6.JPG";
import Image6 from "../assets/homepage/7.jpg";
import Image7 from "../assets/homepage/8.jpg";
import Image8 from "../assets/homepage/9.jpg";
import Image9 from "../assets/homepage/10.jpg";
import Image10 from "../assets/homepage/1.jpg";

const images = [
  Image1,
  Image2,
  Image3,
  Image4,
  Image5,
  Image6,
  Image7,
  Image8,
  Image9,
  Image10,
];

const CarouselNewsSection = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch("https://api.gkaglobal.org/restgka/notification.php")
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "success" && Array.isArray(result.data)) {
          setData(result.data);
        } else {
          console.error("Invalid data format", result);
        }
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  return (
    <div className="carousel-news-container">
      {/* Carousel Section */}
      <div className="carousel-container">
        <Carousel
          autoPlay
          infiniteLoop
          showThumbs={false}
          showStatus={false}
          interval={3000}
          transitionTime={100}
        >
          {images.map((src, index) => (
            <div key={index}>
              <img src={src} alt={`Slide ${index + 1}`} />
            </div>
          ))}
        </Carousel>
      </div>

      {/* News Section */}
      <div className="nofcontainer col-md-4 Res_Css">
        <div className="marquee">
          <div className="marquee-inner">
            {data.length > 0 ? (
              data.map((item) => (
                <div className="news-item" key={item.id}>
                  📰 <strong>{item.Title}</strong>:{" "}
                  <span
                    dangerouslySetInnerHTML={{ __html: item.Description }}
                  />
                </div>
              ))
            ) : (
              <div className="news-item">No news available.</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarouselNewsSection;
